var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.0026L6 8.0026M14 4.0026L6 4.0026M14 12.0026L6 12.0026M3.33333 8.0026C3.33333 8.37079 3.03486 8.66927 2.66667 8.66927C2.29848 8.66927 2 8.37079 2 8.0026C2 7.63441 2.29848 7.33594 2.66667 7.33594C3.03486 7.33594 3.33333 7.63441 3.33333 8.0026ZM3.33333 4.0026C3.33333 4.37079 3.03486 4.66927 2.66667 4.66927C2.29848 4.66927 2 4.37079 2 4.0026C2 3.63441 2.29848 3.33594 2.66667 3.33594C3.03486 3.33594 3.33333 3.63441 3.33333 4.0026ZM3.33333 12.0026C3.33333 12.3708 3.03486 12.6693 2.66667 12.6693C2.29848 12.6693 2 12.3708 2 12.0026C2 11.6344 2.29848 11.3359 2.66667 11.3359C3.03486 11.3359 3.33333 11.6344 3.33333 12.0026Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.d19dfd44ca2f1260b97e0e47e4c2fc88.svg";
export { ForwardRef as ReactComponent };